<template>
  <v-container class="pt-10 pb-16 page-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <!-- PAGE TITLE -->
        <h1 class="page-title mb-4">PRIVACY POLICY (INDIA)</h1>

       

        <!-- 1 -->
        <section>
          <h3>1. INTRODUCTION</h3>
          <p>
            Gigvoc Technologies Private Limited ("Gigvoc," "we," "us") is
            committed to protecting the privacy of our users ("Data
            Principals"). This policy outlines our practices regarding the
            collection, use, and disclosure of digital personal data in
            compliance with the Digital Personal Data Protection (DPDP) Act,
            2023.
          </p>
        </section>

        <!-- 2 -->
        <section>
          <h3>2. DATA WE COLLECT (ITEMIZED)</h3>
          <p>
            Under the DPDP Act, we only collect data necessary for providing
            aggregator services:
          </p>
          <ul>
            <li>
              <strong>Identity Data:</strong>
              Name, age (to verify adulthood), and gender.
            </li>
            <li>
              <strong>Contact Data:</strong>
              Mobile number (verified via OTP) and email address.
            </li>
            <li>
              <strong>Location Data:</strong>
              Real-time GPS coordinates for service matching and navigation.
            </li>
            <li>
              <strong>Service Data:</strong>
              Photos of the repair area, voice notes, and service history.
            </li>
            <li>
              <strong>Transaction Data:</strong>
              UPI IDs or payment status processed via authorized gateways
              (Razorpay, PhonePe). We do not store bank passwords or full card
              numbers.
            </li>
          </ul>
        </section>

        <!-- 3 -->
        <section>
          <h3>3. PURPOSE OF PROCESSING</h3>
          <p>Your data is processed based on your explicit consent to:</p>
          <ul>
            <li>Connect you with a Service Partner for inspection.</li>
            <li>Generate indicative price estimates based on your locality.</li>
            <li>
              Ensure safety through partner verification and live tracking.
            </li>
            <li>Facilitate GST-compliant invoicing and digital payments.</li>
          </ul>
        </section>

        <!-- 4 -->
        <section>
          <h3>4. SHARING WITH SERVICE PARTNERS</h3>
          <p>
            To fulfill your service request, limited data is shared with the
            assigned Service Partner:
          </p>
          <ul>
            <li>
              <strong>Shared Information:</strong>
              Name, phone number, and precise service address.
            </li>
            <li>
              <strong>Data Minimization:</strong>
              Partners are contractually bound to use data only for the booked
              service and must delete it after completion.
            </li>
          </ul>
        </section>

        <!-- 5 -->
        <section>
          <h3>5. DATA PRINCIPAL RIGHTS (DPDP ACT 2023)</h3>
          <ul>
            <li>
              <strong>Right to Access:</strong>
              Request a summary of your personal data and third-party sharing
              details.
            </li>
            <li>
              <strong>Right to Correction & Erasure:</strong>
              Update inaccurate data or request deletion after service
              completion (subject to tax retention).
            </li>
            <li>
              <strong>Right to Withdraw Consent:</strong>
              Withdraw consent via app settings. Withdrawal of location consent
              disables service booking.
            </li>
            <li>
              <strong>Right to Nominate:</strong>
              Nominate an individual to manage your data in case of death or
              incapacity.
            </li>
          </ul>
        </section>

        <!-- 6 -->
        <section>
          <h3>6. DATA STORAGE AND SECURITY</h3>
          <ul>
            <li>
              <strong>Localization:</strong>
              Personal data is stored on secure servers located within India.
            </li>
            <li>
              <strong>Retention:</strong>
              Service records are retained for 7 years to comply with GST and
              audit regulations.
            </li>
            <li>
              <strong>Security:</strong>
              256-bit encryption and regular security audits are implemented as
              required for Data Fiduciaries.
            </li>
          </ul>
        </section>

        <!-- 7 -->
        <section>
          <h3>7. CHILDREN’S PRIVACY</h3>
          <p>
            We do not process personal data of minors (under 18) without
            verifiable parental consent. Any such data discovered will be
            deleted immediately.
          </p>
        </section>

        <!-- 8 -->
        <section>
          <h3>8. GRIEVANCE REDRESSAL</h3>
          <p>
            In accordance with the DPDP Act and IT Rules, we have appointed a
            Grievance Officer:
          </p>
          <ul>
            <li><strong>Grievance Officer:</strong> [Insert Name]</li>
            <li><strong>Email:</strong> [Insert Email]</li>
            <li>
              <strong>Response Time:</strong>
              Acknowledgement within 24 hours and resolution within 15 days.
            </li>
          </ul>
        </section>

        <!-- IMPLEMENTATION NOTES -->
        <section>
          <h3>Implementation Steps for Gigvoc Technologies (India)</h3>
          <ul>
            <li>
              Consent checkboxes must not be pre-selected and require explicit
              affirmative action.
            </li>
            <li>
              Multilingual summaries (Malayalam, Hindi, Tamil) should be
              provided upon request.
            </li>
            <li>
              OTP verification is mandatory to ensure data accuracy compliance.
            </li>
          </ul>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
export default {
  name: "PrivacyIndia",
};
</script>
  
  <style scoped>
.page-title {
  font-size: 34px;
  font-weight: 700;
}

section {
  margin-bottom: 28px;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 6px;
}

p,
li {
  font-size: 15px;
  color: #444;
  line-height: 1.7;
}

ul {
  padding-left: 20px;
}
</style>
  